export default "__VITE_ASSET__B$8kKMyr__"